import React, {Fragment} from 'react';
import {Link} from 'react-router-dom';
import withLifecycles from 'async-lifecycles';
import {Button, Form, Header, Message} from 'semantic-ui-react';
import produce from 'immer';

import {FormWrapper, Wrapper} from './Layout';
import api from '../../store/services/api';
import {ErrorMessages} from '../form-components/ErrorMessages';

class ChangePassword extends React.Component {
  state = {
    loading: false,
    error: {},
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  };
  _mutateState = mutationFn => {
    this.setState(produce(mutationFn));
  };
  _handleInputChanged = (event, {name, value}) => {
    this._mutateState(state => {
      state[name] = value;
    });
  };
  _changePassword = () => {
    const {currentPassword, newPassword, confirmPassword} = this.state;
    withLifecycles(
      () => {
        return api.patch(`/accounts/change-password`, {
          currentPassword,
          newPassword,
          confirmPassword,
        });
      },
      ({loading, data, error}) => {
        this.setState({loading, data, error});
      },
    );
  };

  render() {
    const {
      loading,
      currentPassword,
      newPassword,
      confirmPassword,
      data,
      error,
    } = this.state;
    return (
      <Wrapper>
        <Header textAlign="center">
          <img
            src={`${process.env.PUBLIC_URL}/mm_logo.png`}
            alt="M&M International"
          />
        </Header>
        <FormWrapper attached loading={loading}>
          <Header textAlign="center">Change Password</Header>
          {data &&
            !data.hasErrors && (
            <Fragment>
              <Message success>Your password has been changed.</Message>
              <Button as={Link} to="/" fluid primary>
                  Return to Dashboard
              </Button>
            </Fragment>
          )}
          {(!data || data.hasErrors) && (
            <Form onSubmit={this._changePassword}>
              <Form.Field>
                Current Password
                <Form.Input
                  type="password"
                  name="currentPassword"
                  value={currentPassword}
                  onChange={this._handleInputChanged}
                  autoFocus
                />
              </Form.Field>
              <Form.Field>
                New Password
                <Form.Input
                  type="password"
                  name="newPassword"
                  value={newPassword}
                  onChange={this._handleInputChanged}
                />
              </Form.Field>
              <Form.Field>
                Confirm Password
                <Form.Input
                  type="password"
                  name="confirmPassword"
                  value={confirmPassword}
                  onChange={this._handleInputChanged}
                />
              </Form.Field>
              <ErrorMessages error={error} />
              <div className="stacked-buttons">
                <Button type="submit" primary fluid>
                  Submit
                </Button>
                <Button as={Link} to="/" className="clear" fluid>
                  Return to Dashboard
                </Button>
              </div>
            </Form>
          )}
        </FormWrapper>
      </Wrapper>
    );
  }
}

export default ChangePassword;
